import { forwardRef } from 'react'

const Card = forwardRef(({ 
  children, 
  className = '', 
  variant = 'default',
  hover = false,
  glow = false,
  onClick,
  ...props 
}, ref) => {
  const baseClasses = 'ai-card transition-all duration-300'
  
  const variants = {
    default: 'bg-secondary-800/50 border-secondary-700/50',
    elevated: 'bg-secondary-800/70 border-secondary-700/70 shadow-xl',
    glass: 'bg-secondary-800/30 border-secondary-700/30 backdrop-blur-md',
    gradient: 'bg-gradient-to-br from-secondary-800/50 to-secondary-700/50 border-secondary-600/50'
  }
  
  const hoverClasses = hover ? 'ai-card-hover cursor-pointer' : ''
  const glowClasses = glow ? 'ai-glow-effect' : ''
  
  const classes = `${baseClasses} ${variants[variant]} ${hoverClasses} ${glowClasses} ${className}`

  return (
    <div
      ref={ref}
      className={classes}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  )
})

Card.displayName = 'Card'

export default Card
